var permittedActions = [];

export function setPermittedActions(actions) {
    permittedActions = actions;
}

export function getPermittedActions() {
    return permittedActions;
}
